// Lives in its own file (not inline in subscriptionsFeature.ts) so route
// factories and screens can import these constants without a circular import
// back through subscriptionsFeature.ts -> presentation/routes -> here.
const SUBSCRIPTIONS_LIST =
  "core.subscription_management.subscription_management_list";

export const SUBSCRIPTIONS_VIEW = `${SUBSCRIPTIONS_LIST}.view`;
export const SUBSCRIPTIONS_CREATE = `${SUBSCRIPTIONS_LIST}.create`;
export const SUBSCRIPTIONS_UPDATE = `${SUBSCRIPTIONS_LIST}.update`;
export const SUBSCRIPTIONS_DELETE = `${SUBSCRIPTIONS_LIST}.delete`;
